import Images from "../../config/Images";

interface Plans {
  [name: string]: BenevPlan
}

export const businessPlans: Plans = {
  entrepreneurLite: {
    organizationType: 'Business',
    name: 'Entrepreneur Lite',
    price: 500,
    image: Images.planEntrepreneurLite,
    recommendationType: 'Best for startups',
    recommendationSize: '*up to 20 team members',
    featureSize: '4',
    featureDescription: 'corporate teams',
    featureBackgroundColor: '#FFE9A7',
    paymentDetails: [
      {
        paymentDetail: 'Plan Duration',
        paymentItem: 'Monthly Subscription',
        paymentSubtitle: 'subscription price charged monthly'
      },
      {
        paymentDetail: 'Amount of Teams',
        paymentItem: '4 teams',
        paymentSubtitle: 'additional teams at +$4/month'
      },
      {
        paymentDetail: 'Team Size',
        paymentItem: '5 members/team',
        paymentSubtitle: 'additional members at +$5/month'
      },
      {
        paymentDetail: 'Props Share',
        paymentItem: '20 props/members',
        paymentSubtitle: 'additional props available a la carte'
      }
    ],
    stripePriceId: 'price_1LoEBYFSbc2jn6YhN8asWqeT'
  },
  premium: {
    organizationType: 'Business',
    name: 'Premium',
    price: 1000,
    image: Images.planPremium,
    recommendationType: 'Best for small - mid size businesses',
    recommendationSize: '*21 to 40 team members',
    featureSize: '6',
    featureDescription: 'corporate teams',
    featureBackgroundColor: '#FFD786',
    paymentDetails: [
      {
        paymentDetail: 'Plan Duration',
        paymentItem: 'Monthly Subscription',
        paymentSubtitle: 'subscription price charged monthly'
      },
      {
        paymentDetail: 'Amount of Teams',
        paymentItem: '6 teams',
        paymentSubtitle: 'additional teams at +$4/month'
      },
      {
        paymentDetail: 'Team Size',
        paymentItem: '10 members/team',
        paymentSubtitle: 'additional members at +$5/month'
      },
      {
        paymentDetail: 'Props Share',
        paymentItem: '30 props/members',
        paymentSubtitle: 'additional props available a la carte'
      },

    ],
    stripePriceId: 'price_1LoEBrFSbc2jn6Yha6FgfGps'
  },
  enterprise: {
    organizationType: 'Business',
    name: 'Enterprise',
    price: 600,
    image: Images.planEnterprise,
    recommendationType: 'Best for large corporations',
    recommendationSize: '*41 to 100 team members',
    featureSize: 'unlimited',
    featureDescription: 'corporate teams',
    featureBackgroundColor: '#FED74D',
    paymentDetails: [
      {
        paymentDetail: 'Plan Duration',
        paymentItem: 'Monthly Subscription',
        paymentSubtitle: 'subscription price charged monthly'
      },
      {
        paymentDetail: 'Amount of Teams',
        paymentItem: 'unlimited',
        paymentSubtitle: 'additional teams at +$4/month'
      },
      {
        paymentDetail: 'Team Size',
        paymentItem: 'unlimited',
        paymentSubtitle: 'additional members at +$5/month'
      },
      {
        paymentDetail: 'Props Share',
        paymentItem: 'unlimited',
        paymentSubtitle: '*# of props to be determined by administrators'
      }
    ],
    stripePriceId: 'price_1LoECAFSbc2jn6YhTKSLLhDl'
  }
}

export const nonProfitsPlans: Plans = {
  smallNonProfit: {
    organizationType: 'Non-Profit',
    name: 'Small',
    price: 1000,
    image: Images.planEntrepreneurLite,
    recommendationType: 'Best for startups',
    recommendationSize: '*up to 20 team members',
    featureSize: '4',
    featureDescription: 'corporate teams',
    featureBackgroundColor: '#FFE9A7',
    paymentDetails: [
      {
        paymentDetail: 'Plan Duration',
        paymentItem: 'Monthly Subscription',
        paymentSubtitle: 'subscription price charged monthly'
      },
      {
        paymentDetail: 'Amount of Teams',
        paymentItem: '4 teams',
        paymentSubtitle: 'additional teams at +$4/month'
      },
      {
        paymentDetail: 'Team Size',
        paymentItem: '5 members/team',
        paymentSubtitle: 'additional members at +$5/month'
      },
      {
        paymentDetail: 'Props Share',
        paymentItem: '20 props/members',
        paymentSubtitle: 'additional props available a la carte'
      }
    ],
    stripePriceId: 'price_1LoECbFSbc2jn6Yhah2Tbfer'
  },
  mediumNonProfit: {
    organizationType: 'Non-Profit',
    name: 'Medium',
    price: 2000,
    image: Images.planPremium,
    recommendationType: 'Best for small - mid size businesses',
    recommendationSize: '*21 to 40 team members',
    featureSize: '6',
    featureDescription: 'corporate teams',
    featureBackgroundColor: '#FFD786',
    paymentDetails: [
      {
        paymentDetail: 'Plan Duration',
        paymentItem: 'Monthly Subscription',
        paymentSubtitle: 'subscription price charged monthly'
      },
      {
        paymentDetail: 'Amount of Teams',
        paymentItem: '6 teams',
        paymentSubtitle: 'additional teams at +$4/month'
      },
      {
        paymentDetail: 'Team Size',
        paymentItem: '10 members/team',
        paymentSubtitle: 'additional members at +$5/month'
      },
      {
        paymentDetail: 'Props Share',
        paymentItem: '30 props/members',
        paymentSubtitle: 'additional props available a la carte'
      },

    ],
    stripePriceId: 'price_1LoEDbFSbc2jn6YhaCNijnto'
  },
  largeNonProfit: {
    organizationType: 'Non-Profit',
    name: 'Large',
    price: 3000,
    image: Images.planEnterprise,
    recommendationType: 'Best for large corporations',
    recommendationSize: '*41 to 100 team members',
    featureSize: 'unlimited',
    featureDescription: 'corporate teams',
    featureBackgroundColor: '#FED74D',
    paymentDetails: [
      {
        paymentDetail: 'Plan Duration',
        paymentItem: 'Monthly Subscription',
        paymentSubtitle: 'subscription price charged monthly'
      },
      {
        paymentDetail: 'Amount of Teams',
        paymentItem: 'unlimited',
        paymentSubtitle: 'additional teams at +$4/month'
      },
      {
        paymentDetail: 'Team Size',
        paymentItem: 'unlimited',
        paymentSubtitle: 'additional members at +$5/month'
      },
      {
        paymentDetail: 'Props Share',
        paymentItem: 'unlimited',
        paymentSubtitle: '*# of props to be determined by administrators'
      }
    ],
    stripePriceId: 'price_1LoEE1FSbc2jn6YhNsyrDQ2v'
  }
}

// export const schoolPlans = {
//   premiere: {
//     organizationType: 'School',
//     name: 'Premiere',
//     price: 600,
//     image: Images.planPremiere,
//     recommendationType: 'Best for school size??',
//     recommendationSize: 'max ?? (students/teachers)',
//     featureSize: '1 to 10',
//     featureDescription: 'teams/classes',
//     featureBackgroundColor: '#EEF8FF',
//     paymentDetails: [
//       {
//         paymentDetail: 'Plan Duration',
//         paymentItem: 'Monthly Subscription',
//         paymentSubtitle: 'subscription price charged monthly'
//       },
//       {
//         paymentDetail: 'Amount of Teams',
//         paymentItem: '10 teams (classes)',
//         paymentSubtitle: 'additional teams at +$4/month'
//       },
//       {
//         paymentDetail: 'Props per Student',
//         paymentItem: '20 props/student',
//         paymentSubtitle: `*students props act as 'likes'`
//       },
//       {
//         paymentDetail: 'Props per Teacher',
//         paymentItem: '30 props/teacher',
//         paymentSubtitle: '*only teachers may give props'
//       }
//     ],
//     stripePriceId: 'price_1Ke8LtFSbc2jn6YhpeYbO3A6'
//   },
//   elite: {
//     organizationType: 'School',
//     name: 'Elite',
//     price: 1000,
//     image: Images.planElite,
//     recommendationType: 'Best for school size??',
//     recommendationSize: 'max ?? (students/teachers)',
//     featureSize: '11 to 30',
//     featureDescription: 'teams/classes',
//     featureBackgroundColor: '#DDF1FF',
//     paymentDetails: [
//       {
//         paymentDetail: 'Plan Duration',
//         paymentItem: 'Monthly Subscription',
//         paymentSubtitle: 'subscription price charged monthly'
//       },
//       {
//         paymentDetail: 'Amount of Teams',
//         paymentItem: '30 teams (classes)',
//         paymentSubtitle: 'additional teams at +$4/month'
//       },
//       {
//         paymentDetail: 'Props per Student',
//         paymentItem: '20 props/student',
//         paymentSubtitle: `*students props act as 'likes'`
//       },
//       {
//         paymentDetail: 'Props per Teacher',
//         paymentItem: '30 props/teacher',
//         paymentSubtitle: '*only teachers may give props'
//       }
//     ],
//     stripePriceId: 'price_1Ke8MDFSbc2jn6YhBkkssoN2'
//   },
//   superStar: {
//     organizationType: 'School',
//     name: 'Super Star',
//     price: 1000,
//     image: Images.planSuperStar,
//     recommendationType: 'Best for school size??',
//     recommendationSize: 'max ?? (students/teachers)',
//     featureSize: 'unlimited',
//     featureDescription: 'teams/classes',
//     featureBackgroundColor: '#C7E7FF',
//     paymentDetails: [
//       {
//         paymentDetail: 'Plan Duration',
//         paymentItem: 'Monthly Subscription',
//         paymentSubtitle: 'subscription price charged monthly'
//       },
//       {
//         paymentDetail: 'Amount of Teams',
//         paymentItem: 'unlimited',
//         paymentSubtitle: 'additional teams at +$4/month'
//       },
//       {
//         paymentDetail: 'Props per Student',
//         paymentItem: '20 props/student',
//         paymentSubtitle: `*students props act as 'likes'`
//       },
//       {
//         paymentDetail: 'Props per Teacher',
//         paymentItem: '30 props/teacher',
//         paymentSubtitle: '*only teachers may give props'
//       }
//     ],
//     stripePriceId: 'price_1Ke8MQFSbc2jn6Yhq2mBZeHl'
//   }
// }

// export const familyPlans = {
//   familyPlan: {
//     organizationType: 'Family',
//     name: 'Family Plan',
//     price: 500,
//     image: Images.planFamily,
//     recommendationType: 'Best for ??',
//     recommendationSize: 'max ?? (parents/kids)',
//     featureSize: '2',
//     featureDescription: 'family teams',
//     featureBackgroundColor: '#FFC1BC',
//     paymentDetails: [
//       {
//         paymentDetail: 'Plan Duration',
//         paymentItem: 'Monthly Subscription',
//         paymentSubtitle: 'subscription price charged monthly'
//       },
//       {
//         paymentDetail: 'Amount of Teams',
//         paymentItem: '6 teams',
//         paymentSubtitle: 'additional teams at +$4/month'
//       },
//       {
//         paymentDetail: 'Team Size',
//         paymentItem: '10 members/team',
//         paymentSubtitle: 'additional members at +$5/month'
//       },
//       {
//         paymentDetail: 'Props Share',
//         paymentItem: '30 props/members',
//         paymentSubtitle: 'additional props available a la carte'
//       }
//     ],
//     stripePriceId: 'price_1Ke8MjFSbc2jn6YhMV9lj11A'
//   }
// }
